import './TextCompletionInput.less';
import React, {useEffect, useRef} from 'react';
import ReactDOM from 'react-dom';
import DraftHelper from "../../../helpers/DraftHelper";


export default function TextCompletionInput({content, value: values, onChange: setValues, options: selectOptions, readOnly}) {

    let totalSelects = 0;
    const template = DraftHelper.contentStateToHtml(JSON.parse(content)).replace(/___/g, () => {
        totalSelects++;
        return '<ins></ins>';
    });

    const selectComponents = new Array(totalSelects).fill(null).map((_, index) => (() => {
        return <select
            value={values[index]}
            onChange={ev => {
                const {value} = ev.target;

                const newValues = [];
                for (let i = 0; i < totalSelects; i++) {
                    if (i === index) {
                        newValues[i] = value;
                    } else {
                        if (values[i] === value) {
                            const selectedCount = values.filter(v => v === value).length;
                            const availableCount = selectOptions.filter(opt => opt.value === value).length;
                            if (selectedCount >= availableCount) {
                                newValues[i] = '';
                            } else {
                                newValues[i] = values[i];
                            }
                        } else {
                            newValues[i] = values[i];
                        }
                    }
                }

                setValues(newValues);
            }}
            disabled={readOnly}
        >
            <option key="null" value=""/>
            {
                selectOptions.map((opt, pos) => <option
                    key={pos}
                    value={opt.value}
                >
                    {opt.text || opt.value}
                </option>)
            }
        </select>
    }));

    const tmplRef = useRef();

    useEffect(() => {
        const insTags = tmplRef.current.querySelectorAll('ins');
        insTags.forEach((insTag, index) => {
            const component = selectComponents[index]();
            ReactDOM.render(component, insTag);
        });
    });

    return <div className="text-completion-input">
        <div ref={tmplRef} dangerouslySetInnerHTML={{__html: template}}/>
    </div>;
}
